export default function TestDocumentsDirective() {
  return {
    template: require('./test-documents.html'),
    scope: {
      assessmentId: '=',
      test: '=',
      isEditable: '=',
      fromDialog: '=',
    },
    controller: 'TestDocumentsController',
    controllerAs: 'testDocumentsVM',
    bindToController: true,
    replace: true,
  };
}
